'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var React = require('react');
var times = require('lodash/times.js');
var StepIndicatorDot = require('./StepIndicatorDot.js');
var StepIndicatorLine = require('./StepIndicatorLine.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var times__default = /*#__PURE__*/_interopDefaultLegacy(times);
var _excluded = ["currentStep", "totalSteps"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/**
 * Step indicator
 *
 * Shows the current step and total amount of steps as a line with dots.
 */
var StepIndicator = react.forwardRef(function (props, ref) {
  var styles = react.useMultiStyleConfig('StepIndicator', props);
  var _omitThemingProps = react.omitThemingProps(props),
    currentStep = _omitThemingProps.currentStep,
    totalSteps = _omitThemingProps.totalSteps,
    rest = _objectWithoutProperties__default["default"](_omitThemingProps, _excluded);
  var containerStyles = _objectSpread({
    display: 'flex',
    justifyContent: 'space-between'
  }, styles.container);
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({
    ref: ref
  }, rest, {
    className: utils.cx('chakra-step-indicator', props.className),
    __css: containerStyles
  }), /*#__PURE__*/React__default["default"].createElement(react.StylesProvider, {
    value: styles
  }, times__default["default"](totalSteps, function (index) {
    return /*#__PURE__*/React__default["default"].createElement(react.chakra.div, {
      key: index,
      __css: {
        position: 'relative',
        flex: totalSteps === index + 1 ? 0 : 1
      }
    }, /*#__PURE__*/React__default["default"].createElement(StepIndicatorDot.StepIndicatorDot, {
      isCurrentStep: index + 1 <= currentStep
    }), /*#__PURE__*/React__default["default"].createElement(StepIndicatorLine.StepIndicatorLine, {
      isCurrentStep: index + 1 <= currentStep,
      isLastCurrentStep: index + 1 === currentStep
    }));
  })));
});
StepIndicator.displayName = 'StepIndicator';
exports.StepIndicator = StepIndicator;